import { render } from "./EditSchedule.vue?vue&type=template&id=38b1adc2"
import script from "./EditSchedule.vue?vue&type=script&lang=js"
export * from "./EditSchedule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__